/* @flow */

export const filterMenu = 'filterMenu';
export const sortMenu = 'sortMenu';

export const braindaterContext = 'people';
export const keywordContext = 'keywords';

export const marketSearchMaxResults = 6;
